import { Dictionary } from "src/utils/utils";

export type UserInputType =
    | "checkbox"
    | "choice"
    | "listcollector"
    | "reference"
    | "string"
    | "maskedstring"
    | "textarea";
export type UserInput = {
    name: string | Array<string>;
    value: string | Array<string> | boolean;
    type: UserInputType;
    label: string;
    required?: boolean;
    order?: number;
    snTableNameRef?: string;
    refQual?: string;
    choices?: Array<String>;
};

export type UserInputs = Dictionary<UserInput>;

export type FormInput = {
    value: string | boolean | string[];
    type: UserInputType;
    required: boolean;
    label: string;
    choices?: string[];
    snTableNameRef?: string;
    // used for listcollectors and reference
    // we should show the user human readable names but for the backend to run
    // we need the ciSysId of these things which are store in the value.
    name?: string | boolean | string[];
};

export function setInitialProcessInputs(processInputs: UserInputs) {
    const inputs: Dictionary<FormInput> = {};
    Object.entries(processInputs).forEach(([k, v]) => {
        // todo: clean this up
        const t = v.type;
        const r = v.required;
        const l = v.label;
        switch (t) {
            case "string":
            case "maskedstring":
            case "textarea":
                inputs[k] = { value: "", type: t, required: !!r, label: l };
                break;
            case "choice":
                inputs[k] = { value: "", type: t, required: !!r, label: l, choices: v.choices as string[] };
                break;
            case "checkbox":
                inputs[k] = { value: false, type: t, required: !!r, label: l };
                break;
            case "reference":
                inputs[k] = { value: "", name: "", type: t, required: !!r, label: l, snTableNameRef: v.snTableNameRef };
                break;
            case "listcollector":
                inputs[k] = { value: [], name: [], type: t, required: !!r, label: l };
                break;
            default:
                throw new Error(`Unknown Project User Input Type: ${v.type}`);
        }
    });
    return inputs;
}
